<template>
  <div>
    <div v-show="isActive" ref="backDiv" id="back-div" class="back-overlay"></div>
    <div id="drawer" class="drawer-overlay" :class="{ active: isActive }">
      <a class="clearfix">
        <span v-if="!isMobile()" @click.prevent="$emit('closed')" class="material-icons ml-3 mt-3 overly_close">close</span>
        <span v-if="isMobile()" @click.prevent="$emit('closed')" class="material-icons ml-3 mt-3 overly_close">arrow_back</span>
      </a>
      <login v-if="isActive" v-show="getIsLogin" @show-register="isLogin=false" @close-overlay="close()" 
        @show-term="showModal=true" :showedindrawer="true" />
      <register v-if="isActive" v-show="!getIsLogin" @show-login="showLogin()" @close-overlay="close()" 
        @show-term="showModal=true" :showedindrawer="true"/>
    </div>
    <termsAndConditionsModal v-if="showModal" @close-modal="closeModal"/>
  </div>
</template>

<script>
import login from "../user/login.vue";
import register from "../user/register.vue";
import { $$ } from "./../../sharedscripts/OO_jquery";
import { mapActions, mapGetters, mapMutations } from "vuex";
import termsAndConditionsModal from "../shop/partials/termsAndConditionsModal.vue";
import store from "../../../src/store";

export default {
  components: {
    login,
    register,
    termsAndConditionsModal
  },
  name: "Overlay",
  data(){
    return {
      showModal: false
    }
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(["user", "currentStoreDoc", "showOverlayLogin"]),
    getIsLogin() {
      if(this.isLogin && this.showOverlayLogin)
      {
        return true;
      }else
      {
        return false;
      }
    }
  },
  watch: {
    isActive() {
      if (this.isActive) {
        this.isLogin = true;
        $$('body,html').addClass('draweractive');
      }else{
        $$('body,html').removeClass('draweractive');
      }
    },
  },
  mounted() {
    var that = this;
    this.$refs.backDiv.onclick = function() {
      if (that.isActive) {
        that.$emit("closed");
      }
    };
      if (this.isActive) {
        this.isLogin = true;
        $$('body,html').addClass('draweractive');
      }else{
        $$('body,html').removeClass('draweractive');
      }
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setShowOverlayLogin"]),
    close() {
      if (this.isActive) {
        this.$emit("closed");
      }
    },
    closeModal() {
      this.showModal = false;
    },
    showLogin() {
      this.isLogin=true;
      store.commit("setShowOverlayLogin")
    }
  }
};
</script>
<style scoped>
  .overly_close {
    cursor: pointer;
  }
</style>